module.exports = __webpack_public_path__ + "static/media/Calibre-RegularItalic.3a445970.woff";